import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { QuerySetup } from '@imago/api-client-for-react'
import { useSignedIn } from "../queries/auth.ts"
import { SignIn } from "./SignIn.tsx"
import { PatientsApp } from "./PatientsApp.tsx"
import { Suspense } from "react"
import { FatUserQuery } from '../queries/user.ts'
import { ErrorBoundary } from '@sentry/react'
import { AppUpdateBanner } from './PWA.tsx'

const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError: error => {
			console.error(error)
		}
	}),
	mutationCache: new MutationCache({
		onError: error => {
			console.error(error)
		}
	})
})

function LoadingScreen() {
	return <div className="loading">
		<x-spinner/>
	</div>
}

export function App() {
	return <>
		<QueryClientProvider client={queryClient}>
			<QuerySetup queries={[FatUserQuery]}>
				<AppUpdateBanner/>
				<ErrorBoundary fallback={<div/>}>
					<Suspense fallback={<LoadingScreen/>}>
						<_App/>
					</Suspense>
				</ErrorBoundary>
			</QuerySetup>
		</QueryClientProvider>
	</>
}

function _App() {
	const signedIn = useSignedIn()

	if (signedIn === undefined) return
	return !signedIn ? <SignIn/> : <PatientsApp/>
}
